export default __webpack_public_path__ + "static/media/Laptop_Blue_Circle.8528403a.png";